import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import familyDetailService from "../service-api/familyDetailService";

// Initial state
const initialState = {
  data: [],
  activeRoles: [],
  error: null,
  isLoading: true,
  isFormSubmitting: false,
};

export const fetchFamilyDetailByCandidateID = createAsyncThunk(
  "data/fetchFamilyDetailByCandidateID",
  async (id) => {
    const response = await familyDetailService.fetchFamilyDetailByCandidateID(
      id
    );
    return response.data;
  }
);

export const updateFamilyDetail = createAsyncThunk(
  "data/updateFamilyDetail",
  async ({ id, formData }) => {
    const response = await familyDetailService.updateFamilyDetail(id, formData);
    return response.data;
  }
);

export const addFamilyDetail = createAsyncThunk(
  "data/addFamilyDetail",
  async (obj) => {
    const response = await familyDetailService.addFamilyDetail(obj);
    return response.data;
  }
);

export const deleteFamilyDetail = createAsyncThunk(
  "data/deleteFamilyDetail",
  async (id) => {
    const response = await familyDetailService.deleteFamilyDetail(id);
    return response.data;
  }
);

// Create slice
const familyDetailSlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFamilyDetailByCandidateID.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchFamilyDetailByCandidateID.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.value;
      })
      .addCase(fetchFamilyDetailByCandidateID.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateFamilyDetail.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(updateFamilyDetail.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(updateFamilyDetail.rejected, (state, action) => {
        state.isFormSubmitting = false;
        state.error = action.error.message;
      });

    builder
      .addCase(addFamilyDetail.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(addFamilyDetail.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(addFamilyDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(deleteFamilyDetail.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(deleteFamilyDetail.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(deleteFamilyDetail.rejected, (state, action) => {
        state.isFormSubmitting = false;
        state.error = action.error.message;
      });
  },
});

export default familyDetailSlice.reducer;
